import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
//import { lazy, Suspense } from "react";

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header';
import Home from "./components/Home";
import Footer from "./components/Footer";
import Listing from "./components/Listing";
import Services from "./components/Services";
import Details from "./components/Details";
import Login from "./components/Login";
import Register from "./components/Register";
//import HeaderDb from "./components/HeaderDb";
import Dashboard from "./components/Dashboard";
import PersonalDetails from "./components/PersonalDetails";
import BusinessDetails from "./components/BusinessDetails";
import ContactDetails from "./components/ContactDetails";
import DbPhotoGallery from "./components/DbPhotoGallery";
import ChangePassword from "./components/ChangePassword";
import ProtectedRoute from "./components/ProtectedRoute";
import Logout from "./components/Logout";

//import LogoutUser from "./components/LogoutUser";
import { AnimatePresence, motion } from "framer-motion";
import Agriculture from "./components/webpages/Agriculture";
import AgricultureDetails from "./components/webpages/AgricultureDetails";
import BeautyParlour from "./components/webpages/BeautyParlour";
import Doctors from "./components/webpages/Doctors";
import DoctorsDetails from "./components/webpages/DoctorsDetails";
import Photographers from "./components/webpages/Photographers";
import PhotographersDetails from "./components/webpages/PhotographersDetails";
import BeautyParlourDetails from "./components/webpages/BeautyParlourDetails";
import SearchResult from "./components/webpages/SearchResult";




function Layout() {

  const location = useLocation();

  return (
    <>
      {
        location.pathname === "/dashboard" ||
          location.pathname === "/personal-details" ||
          location.pathname === "/business-details" ||
          location.pathname === "/contact-details" ||
          location.pathname === "/photo-gallery" ||
          location.pathname === "/change-password" ? <Header /> : <Header />
        //location.pathname === "/change-password"  ? <HeaderDb /> : <Header />
      }
    </>
  );
}

function App() {
  return (
    <div>

      <BrowserRouter>
        <Layout />
        <AnimatePresence mode="wait">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/search" element={<SearchResult />} />
              <Route path="/services" element={<Services />} />
              <Route path="/listing" element={<Listing />} />
              <Route path="/agriculture" element={<Agriculture />} />
              <Route path="/agriculture/:slug" element={<AgricultureDetails />} />
              <Route path="/beauty-parlour" element={<BeautyParlour />} />
              <Route path="/beauty-parlour/:slug" element={<BeautyParlourDetails />} />
              <Route path="/doctors" element={<Doctors />} />
              <Route path="/doctors/:slug" element={<DoctorsDetails />} />
              <Route path="/photographers" element={<Photographers />} />
              <Route path="/photographers/:slug" element={<PhotographersDetails />} />
              <Route path="/details" element={<Details />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/personal-details" element={<ProtectedRoute><PersonalDetails /></ProtectedRoute>} />
              <Route path="/business-details" element={<ProtectedRoute><BusinessDetails /></ProtectedRoute>} />
              <Route path="/contact-details" element={<ProtectedRoute><ContactDetails /></ProtectedRoute>} />
              <Route path="/photo-gallery" element={<ProtectedRoute><DbPhotoGallery /></ProtectedRoute>} />
              <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
              <Route path="/logout" element={<Logout />} />
            </Routes>
          </motion.div>
        </AnimatePresence>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
